import { Box, Button, Flex, Table, TableContainer, Tbody, Td, Tr } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableActions from '../../common/TableActions/TableActions';
import TableHeader from '../../common/TableHeader/TableHeader';
import useItemLister from '../../core/hooks/useItemLister';
import { Page } from '../../core/models';

const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;
const FILTERS = ['title'];

const COLS: {
  label: string;
  sort?: string;
  isNumeric?: boolean;
}[] = [
  {
    label: 'Title',
    sort: 'title',
  },
  {
    label: 'Slug',
    sort: 'slug',
  },
  {
    label: 'Published',
  },
  {
    label: 'Actions',
    isNumeric: true,
  },
];

interface IProps {
  world?: boolean;
}

function PageLister({ world }: IProps) {
  const navigate = useNavigate();
  const {
    items,
    activeId,
    deleteItem,
    deleteLoading,
    Lister,
    sort,
    changeSort,
    setIsActive,
    duplicateItem,
    createLoading,
  } = useItemLister({
    endpointSingle: 'page',
    endpointPlural: world ? 'pages?world_page=true' : 'pages?world_page=null',
    filters: FILTERS,
  });

  useEffect(() => {
    setIsActive(true);

    return () => {
      setIsActive(false);
    };
  }, []);

  return (
    <>
      <Flex>
        <h1 className="h3">Page</h1>
        <Button
          colorScheme="messenger"
          type="button"
          shadow="lg"
          ml="auto"
          onClick={() => navigate(`/${world ? 'world-page' : 'page'}/new`)}
        >
          Create New
        </Button>
      </Flex>
      {Lister({
        children: (
          <Box my={5}>
            <TableContainer fontSize="1rem" boxShadow="xl">
              <Table variant="striped" colorScheme="facebook">
                <TableHeader cols={COLS} sort={sort} changeSort={changeSort} />
                <Tbody>
                  {items?.map((page: Page) => (
                    <Tr key={page._id}>
                      <Td py={3} verticalAlign="middle">
                        <button
                          style={{ padding: '6px' }}
                          type="button"
                          onClick={() => navigate(`/${world ? 'world-page' : 'page'}/${page._id}`)}
                        >
                          {page.title}
                        </button>
                      </Td>
                      <Td py={3} verticalAlign="middle" style={{ color: '#218ce7' }}>
                        <a
                          href={`${WEBSITE_URL}${page.parent ? `/${page.parent}` : ''}/${
                            page.slug
                          }`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {page.slug}
                        </a>
                      </Td>
                      <Td
                        py={3}
                        verticalAlign="middle"
                        style={{ color: page.published ? 'green' : '' }}
                      >
                        {page.published ? 'Published' : 'Unpublished'}
                      </Td>
                      <Td py={3} verticalAlign="middle">
                        <TableActions
                          item={page}
                          path={world ? 'world-page' : 'page'}
                          activeId={activeId}
                          deleteItem={deleteItem}
                          duplicateItem={duplicateItem}
                          deleteLoading={deleteLoading}
                          showDuplicateButton
                          createLoading={createLoading}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        ),
      })}
    </>
  );
}

export default PageLister;
